import { SelectPageEffectProps } from "./type"
import React, { useLayoutEffect, useRef } from "react"
import useNavigation from "~hooks/useNavigation"
import styled from '~/ui/styled'

const ConfirmPressable = styled.Pressable``

const ConfirmButton = styled.Text<{ active: boolean }>`
  color: ${({ theme, active }) => (active ? theme.colors.primary : theme.colors.secondaryText)};
  font-size: ${({ theme }) => theme.fontSizes.md};
`

const useSelectPageEffect = (props: SelectPageEffectProps) => {
  const { canSubmit, selecteds, onSubmit } = props
  const navigation = useNavigation()
  const propsRef = useRef(props)
  propsRef.current = props

  useLayoutEffect(() => {
    navigation.setOptions({
      headerRight: function HeaderRight() {
        const { canSubmit, selecteds, onSubmit } = propsRef.current
        return (
          <ConfirmPressable onClick={onSubmit}>
            <ConfirmButton active={canSubmit}>确定({selecteds.length})</ConfirmButton>
          </ConfirmPressable>
        )
      },
    })
    return () => {
      navigation.setOptions({ headerRight: undefined })
    }
  }, [navigation, canSubmit, selecteds.length])
}

export default useSelectPageEffect
